// Rend cliquable n'importe quel élément portant `data-target-url`.
// Les clics sur des éléments interactifs réels (liens, boutons, champs de
// formulaire) ne sont pas interceptés - ces éléments gardent leur
// comportement natif (hover, focus, navigation clavier, clic droit, SEO).
(function () {
  if (window.__clickableWrapperBound) return;
  window.__clickableWrapperBound = true;

  var INTERACTIVE = 'a, button, input, textarea, select, label, [role="button"], [role="link"]';

  function resolveTarget(event) {
    var wrapper = event.target.closest("[data-target-url]");
    if (!wrapper) return null;
    if (event.target.closest(INTERACTIVE)) return null;
    var url = wrapper.getAttribute("data-target-url");
    if (!url) return null;
    return url;
  }

  document.addEventListener("click", function (event) {
    // bouton principal uniquement
    if (event.button !== 0) return;
    var url = resolveTarget(event);
    if (!url) return;
    event.preventDefault();
    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      window.open(url, "_blank", "noopener");
    } else {
      window.location.href = url;
    }
  });

  // Clic molette / bouton du milieu → nouvel onglet
  document.addEventListener("auxclick", function (event) {
    if (event.button !== 1) return;
    var url = resolveTarget(event);
    if (!url) return;
    event.preventDefault();
    window.open(url, "_blank", "noopener");
  });
})();
